export default __webpack_public_path__ + "static/media/longCloud6.343fe78e.webp";